import React, { ChangeEvent } from 'react';
import { Card } from 'components';
import { Button, Stack, Typography } from '@mui/material';
import { CloudUploadOutlined } from '@mui/icons-material';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

export const InvoiceFileUploader = ({ onFileUpload }: { onFileUpload: (file: File) => void }) => {
  const [{ canDrop }, drop] = useDrop(() => ({
    accept: NativeTypes.FILE,
    drop: ({ files }: { files: FileList }) => {
      const file = files[0];
      if (file) onFileUpload(file);
    },
    collect: (monitor) => ({ canDrop: monitor.canDrop() }),
  }));

  const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }
    onFileUpload(file);
    // this will ensure that the file input is cleared after the file is uploaded
    e.currentTarget.value = '';
  };

  return (
    <Button
      ref={drop}
      size="large"
      disableRipple
      component="label"
      sx={{ display: 'block', p: 0, opacity: canDrop ? 0.4 : 1, textTransform: 'none' }}
    >
      <Card sx={{ borderStyle: 'dashed', border: 3, borderColor: 'primary.main' }}>
        <Stack alignItems="center">
          <CloudUploadOutlined sx={{ fontSize: 60, color: 'primary.main' }} />
          <Typography variant="h4" color="primary.main" mb={4}>
            Drag and drop or click to upload invoice
          </Typography>
        </Stack>
      </Card>
      <input hidden type="file" onChange={onFileChange} accept="application/pdf" data-testid="invoiceFileUpload" />
    </Button>
  );
};
